const folderKeys = {
  all: ['folders'],
  archived: () => [...folderKeys.all, 'archived'],
  byFolderId: (id: string) => [...folderKeys.all, id],
  nameList: (parentId?: string) => [...folderKeys.all, 'nameList', parentId],
  byParentId: (parentId?: string) => [...folderKeys.all, 'parentId', parentId || undefined],
  folderStats: (id: string) => [...folderKeys.byFolderId(id), 'stats'],
  folderHistory: (id: string) => [...folderKeys.byFolderId(id), 'history']
};

export default folderKeys;
